<script setup lang="ts">
import Mapbox from 'mapbox-gl';

import { MAPBOX_PROVIDE_INJECT } from '~/composables/mapbox/map';
import type { MapBoxInjected } from '~/composables/mapbox/map';

const navigationControl = shallowRef<mapboxgl.NavigationControl>();
const scaleControl = shallowRef<mapboxgl.ScaleControl>();

const { mapbox } = inject(MAPBOX_PROVIDE_INJECT) as MapBoxInjected;

watch(mapbox, () => {
  if (!mapbox.value) return;
  // https://docs.mapbox.com/mapbox-gl-js/api/markers/#marker
  navigationControl.value = new Mapbox.NavigationControl();
  scaleControl.value = new Mapbox.ScaleControl();
  mapbox.value.addControl(navigationControl.value);
  mapbox.value.addControl(scaleControl.value);
  // NOTE: Immediate to been trigger during tests
  // Without this
  // • since “provide” will be injected before “mount’
  // • new Mapbox.Marker will never been called
}, { immediate: true });

// Template can't be empty. Needed to avoid Vue warning without rendering anything
// “Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.”
const render = () => null;
</script>

<template>
  <render />
</template>
